import WoundTherapySelection from './WoundTherapySelection';

export default WoundTherapySelection;
